<template>
  <el-dialog
      custom-class="lesson-lineUp-dialog"
      width="600px"
      center
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
    <div class="lineUp-img">
      <img src="~@/assets/imgs/icon/time.png" alt=""/>
    </div>
    <br/>
    <p>{{ waitingMsg }}</p>
    <h2 class="lineUp-wait">
      你已等候<span>{{ formatWaitingTime }}</span>，<br/>
      前面还有<span>{{ activeInfo.wait }}</span>人在等候
    </h2>
    <div class="lineUp-btns">
      <el-button type="success" @click="closeLineUp">取消排队</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {mapGetters} from "vuex";
import AppWebSocket, {getLineupUrl} from "@/api/websocket";
import {getExpDetailByUid} from "@/api/exp/experiment";
import {startExp} from "@/api/lab/experiment";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    lessonExpUid: {
      type: String,
      default: "",
    },
    expUid: {
      type: String,
      default: "",
    },
    callbackPathName: {
      type: String,
      default: 'lessonExpStart'
    },
    shenbaoKey: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      // 对话框显隐
      dialogVisible: false,
      // 排队会话
      socket: null,
      // 排队等候计时
      waitingTimer: null,
      // 已等候时间(秒)
      waitingTime: 0,
      // 保持ws连接计时器
      keepTimer: null,
      waitingMsg: "",
      // 当前操作的课程实验信息
      activeInfo: {
        wait: 0, // 排队等待人数
        // waitTime: null, // 预计等待的时间
      },
    }
  },
  watch: {
    visible(val) {
      if (this.dialogVisible === val) {
        return;
      }

      this.dialogVisible = val

      if (val) {
        this.openWs()
      }
    },
    dialogVisible(val) {
      if (this.visible === val) {
        return;
      }
      this.$emit("update:visible", val);
    },
  },
  computed: {
    ...mapGetters(['userInfo']),
    formatWaitingTime() {
      let time = this.waitingTime
      let str = ''
      let min = Math.floor(time % 3600)
      let h = Math.floor(time / 3600)
      if (h > 0)
        str += h + '小时'
      let m = Math.floor(min / 60)
      if (m > 0)
        str += m + '分'
      let s = time % 60
      str += s + '秒'
      return str
    }
  },
  methods: {
    // 连接WebSocket，排队
    openWs() {
      const uid = this.lessonExpUid
      if (uid == null || uid === "") {
        this.$message.warning("找不到指定课堂实验")
        return
      }

      this.waitingMsg = "正在获取实验项目信息"
      // 获取实验项目关联的软件信息
      getExpDetailByUid(this.expUid)
          .then((res = {softs: null}) => {
            this.waitingMsg = "正在获取软件信息"
            const softsStr = res.softs || JSON.stringify([])
            try {
              const softs = JSON.parse(softsStr) || []
              const softFirst = softs[0]
              const {appprama = {layaUrl: null}} = softFirst || {}
              let layaUrl = false
              if (res.content.indexOf('<soft>') > -1) {
                  const outHtml = res.content.split(/<soft>|<\/soft>/)
                  layaUrl = outHtml[1].indexOf('layaUrl') > -1
              }
              // 判断当前实验为laya3D仿真实验
              if (appprama.layaUrl || layaUrl) {
                const {id} = this.userInfo
                this.waitingMsg = "正在建立实验数据"
                startExp({
                  expUid: uid,
                  userId: id
                })
                    .then(labExp2User => {
                      this.toStartExpPage(labExp2User, 0)
                    })
                    .catch((error) => {
                      window.console.error(error)
                    })
              } else {
                this.startLineUp(uid)
              }
            } catch (e) {
              window.console.error(e)
            }
          })
    },
    addWebSocketEvents() {
      const {socket} = this
      if (socket == null) {
        return
      }

      this.socket.onopen = this.wsOnOpen
      this.socket.onmessage = this.wsOnMessage
      this.socket.onerror = this.wsOnError
      this.socket.onclose = this.wsOnClose
    },
    /**
     * 开始排队的WebSocket连接
     */
    startLineUp(uid) {
      this.waitingMsg = "准备排队"
      if (this.waitingTimer)
        clearInterval(this.waitingTimer)
      this.waitingTime = 0
      this.waitingTimer = setInterval(() => {
        this.waitingTime++
      }, 1000)

      if (this.socket) {
        return;
      }
      // 排队、检查预约
      const url = getLineupUrl(uid)
      this.socket = AppWebSocket(url)
      this.addWebSocketEvents()
    },
    /**
     * 取消排队
     */
    closeLineUp() {
      this.$confirm('此操作将取消排队, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.closeWs()
      }).catch(() => {
      })
    },
    /**
     * An event listener to be called when the connection is opened.
     */
    wsOnOpen() {
      this.waitingMsg = "排队中，请稍后"
      if (this.keepTimer)
        clearInterval(this.keepTimer)
      this.keepTimer = setInterval(() => {
        if (this.socket)
          this.socket.send('keep')
        else if (this.keepTimer)
          clearInterval(this.keepTimer)
      }, 500)
    },
    /**
     * An event listener to be called when a message is received from the server.
     * @param ev
     */
    wsOnMessage(ev) {
      let {data} = ev
      let obj = {} // 格式化接收到的值
      let arr = data.split(':') || []
      arr.map((item, index) => {
        if (index % 2 === 1) {
          obj[arr[index - 1]] = item
        }
      })
      let {
        lineupNum,
        startExp,
        sid,
        labExp2User,
        message
      } = obj
      // 发生错误
      if (startExp === 'false') {
        this.$message.error(message || "未知错误")
        this.closeWs()
      } else if (lineupNum) {
        this.dialogVisible = true
        this.activeInfo.wait = Number(lineupNum) + 1 || 1
        // this.activeInfo.waitTime = waitTime
      } else if (startExp === 'true' && labExp2User) {
        if (sid) {
          // 进入做实验页面
          this.toStartExpPage(labExp2User, sid)
        } else
          this.$message.error('未获取实验记录！')
        this.closeWs()
      }
    },
    /**
     * An event listener to be called when an error occurs.
     * @param ev
     */
    wsOnError(ev) {
      let {reason = ''} = ev
      this.$message.warning(reason || "未知错误")
      this.closeWs()
    },
    /**
     * An event listener to be called when the connection is closed.
     * @param ev
     */
    wsOnClose(ev) {
      let {reason = '', code} = ev
      if (code === 1002) {
        this.$message.error("非法请求，无法连接 (1002)")
      } else {
        if (reason)
          this.$message.warning(reason)
      }
      this.closeWs()
    },
    // 关闭WebSocket连接，取消排队
    closeWs() {
      if (this.socket) {
        if (this.socket.readyState < WebSocket.CLOSING) {
          this.socket.close()
        }
        this.socket = null
      }

      if (this.keepTimer) {
        clearInterval(this.keepTimer)
        this.keepTimer = null
      }

      this.waitingTime = 0
      if (this.waitingTimer) {
        clearInterval(this.waitingTimer)
        this.waitingTimer = null
      }

      this.dialogVisible = false
    },
    toStartExpPage(labExp2User, sid) {
      this.$router.push({
        name: this.callbackPathName,
        params: {
          labExpUid: this.lessonExpUid,
          uid: labExp2User,
          type: "remote",
          ticket: sid,
          key: this.shenbaoKey
        }
      })
    },
  }
}

</script>
